namespace TabAurous.ECommerce {
    export namespace ECommOrderService {
        export const baseUrl = 'ECommerce/Order';

        export declare function Create(request: Serenity.SaveRequest<ECommOrderRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommOrderRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetCustomerandProductDetails(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ECommOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommerce/Order/Create",
            Update = "ECommerce/Order/Update",
            Delete = "ECommerce/Order/Delete",
            Retrieve = "ECommerce/Order/Retrieve",
            GetCustomerandProductDetails = "ECommerce/Order/GetCustomerandProductDetails",
            List = "ECommerce/Order/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetCustomerandProductDetails', 
            'List'
        ].forEach(x => {
            (<any>ECommOrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
